export default __webpack_public_path__ + "static/media/celo.4a83e068.png";